import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useStaticSelect } from "src/hooks/form/useSelect";
import { useReduxState } from "src/hooks/useRedux";

const usePackagingTypes = <T>(props: useFieldProps<T>) => {
	const field = useStaticSelect<ReturnType<typeof getOptions>, T>(props);
	const validPkgTypesByMode: Record<string, string> = useReduxState(
    ["masterData", "execution", "validContainerOrPackageTypesBasedOnMode"]
  ).value;

	const validPkgTypes = validPkgTypesByMode.AIRCARGO;
  React.useEffect(() => {
    field.setOptionsData(getOptions(), (data) => {
      return data || [];
    });
  }, []);

  const getOptions = () => {
    return Object.keys(validPkgTypes).map(el => ({ key: el, label: validPkgTypes[el]}));
  };

  return field;
};

export default usePackagingTypes;
